export default function createEventHandlerMatching(selector, handler) {
    return (e) => {
        if (e.target.matches(selector)) {
            handler(e, e.target);
        }
        else {
            const element = e.target.closest(selector);
            if (element !== null) {
                handler(e, element);
            }
        }
    };
}
